export default {
      id: "patient-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#patient",
      toString: function () {
        return this.url;
      }
    }